/**
 * @name dataIdentifiers
 */
const dataIdentifiers = {
  CURRENT_APP_USERS: "CURRENT_APP_USERS",
};
export default dataIdentifiers;
